import React from "react";
import DOMPurify from "dompurify";

interface Props {
  hotelName?: string;
  address: string;
  mapUrl?: string;
  checkIn?: string;
  checkOut?: string;
  adults?: number;
  children?: number;
  rooms?: number; // <-- added
  price: number | null;
  currency: string;
  breakdown?: any[];
  prebookData?: any;
  onBookNow?: () => void;
  paxRooms?: any[];
  selectedRoom?: any | null;
}

const HotelStickyContent: React.FC<Props> = ({
  hotelName,
  address,
  mapUrl,
  checkIn,
  checkOut,
  adults,
  children,
  rooms,
  price,
  currency,
  breakdown,
  prebookData,
  onBookNow,
  selectedRoom,
}) => {
  const firstRoom = prebookData?.HotelResult?.[0]?.Rooms?.[0] || selectedRoom;

  const bookDisabled = !selectedRoom || !prebookData; // require selection + prebook success

  return (
    <div className="card sticky-top shadow-sm" style={{ top: "80px" }}>
      <div className="card-body">
        <h5 className="mb-3">Booking Summary</h5>

        {hotelName && <h6 className="fw-bold">{hotelName}</h6>}
        <p className="mb-1">
          <i className="fa-solid fa-location-dot me-2 text-danger"></i> {address}
        </p>
        {mapUrl && (
          <p className="small mb-2">
            📍 <a href={mapUrl} target="_blank" rel="noreferrer">See Location</a>
          </p>
        )}

        {(checkIn || checkOut) && (
          <p className="small mb-2">
            <i className="fa-regular fa-calendar me-2"></i>
            {checkIn} → {checkOut}
          </p>
        )}

        {/* show guests / rooms clearly */}
        <p className="small mb-2">
          <i className="fa-solid fa-user-group me-2"></i>
          {adults ?? 0} Adults{children ? `, ${children} Children` : ""}{" "}
          {typeof rooms !== "undefined" && `• ${rooms} Room${rooms > 1 ? "s" : ""}`}
        </p>

        <h4 className="text-primary mt-3">{currency} {price ? price.toLocaleString() : "--"}</h4>

        {breakdown && breakdown.length > 0 && (
          <div className="mt-3">
            <h6>Fare Breakdown</h6>
            <ul className="list-unstyled small ms-2">
              {breakdown.map((item: any, idx: number) => (
                <li key={idx}>
                  <i className="fa-solid fa-circle-dot me-2 text-secondary"></i>
                  {item.RoomRate && `Room Rate: ${item.RoomRate}`}
                  {item.RoomTax && ` | Tax: ${item.RoomTax}`}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="mt-4">
          <h6 className="text-success">Room</h6>
          <p className="small mb-2">
            {firstRoom ? (Array.isArray(firstRoom?.Name) ? firstRoom?.Name.join(", ") : firstRoom?.Name) : "No room selected"}
          </p>

          <div className="d-grid">
            <button
              className={`btn btn-primary ${bookDisabled ? "disabled" : ""}`}
              onClick={() => !bookDisabled && onBookNow && onBookNow()}
              aria-disabled={bookDisabled}
              title={bookDisabled ? "Select a room to enable booking" : "Proceed to guest details"}
            >
              {bookDisabled ? "Select a room to book" : "Book Now"}
            </button>
            {bookDisabled && <small className="text-muted mt-2">Please select a room card from the list to continue.</small>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelStickyContent;
